import './turbo';
import './script_loader';
import './scroll_detection';
import './cookie-consent';
import './lateral_menu';
import './loaders';
import './review';
import './share';
import { PopUpLink } from './pop_up_link';

new PopUpLink();
global.selectBottomMenu = (view) => import('./bottom_menu').then(module => module.selectBottomMenu(view));
global.menuLoader = (loaderHtml) => import('./bottom_menu').then(module => module.menuLoader(loaderHtml));
global.removeParamsFromUrl = (paramsToRemove) => import('./utils').then(module => module.removeParamsFromUrl(paramsToRemove));
import('./remove_capitalkoala').then(module => module.cleanCapitalKoala());
import('./autoreplace');
